module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 97
// module chunks = 0 1 2 3 4